import { resolveOrganizedTourDestinationImage } from "../../../utils/resolveOrganizedTourDestinationImage";
import {
  organizedTourLooksLikeDirectImageUrl,
  upgradeOrganizedTourRemoteImageUrl,
} from "../../../utils/organizedTourHeroImageSsot";

/**
 * אותה עדיפות כמו בתצוגת כרטיס/תוצאות: תמונה מה־VM, ואז תמונת יעד (curated).
 * דוחה URL שאינם תמונה ישירה (ברושורים HTML/PDF וכו׳).
 *
 * @param {object|null|undefined} cardVm
 * @param {object|null|undefined} rawDeal  שורת חיפוש / selectedResult / raw
 */
export function pickOrganizedTourHeroImageUrl(cardVm, rawDeal) {
  const raw = rawDeal ?? cardVm?.raw ?? null;
  const fromVm = cardVm?.imageUrl ? String(cardVm.imageUrl).trim() : "";
  let candidate = fromVm;
  if (!candidate) {
    const dest = resolveOrganizedTourDestinationImage(raw, {
      tourName: cardVm?.tourName,
      routeLabel: cardVm?.routeLabel,
      routeCities: cardVm?.routeCities,
    });
    candidate = dest?.resolvedImage ? String(dest.resolvedImage).trim() : "";
  }
  if (!candidate) return "";
  if (!organizedTourLooksLikeDirectImageUrl(candidate)) return "";
  const upgraded = upgradeOrganizedTourRemoteImageUrl(candidate);
  return upgraded || candidate;
}
